import axios, { AxiosInstance } from "axios";

/* global process */

const REACT_APP_BASE_PUBLIC_API_URL = process.env.REACT_APP_BASE_PUBLIC_API_URL;

const instance: AxiosInstance = axios.create({
  baseURL: REACT_APP_BASE_PUBLIC_API_URL,
});

export default instance;
